import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Table, CardBox,
    DropdownButton, SearchWithAction,
    EmptyState, Page, FormSelect
} from '../../components'
import { retrieve } from '../../actions/users-actions'
import { push } from '../../actions/nav-actions'
import { deleteUser, fetchORganizationsNames } from '../../api'
import { notify, testRegex } from '../../utils';
import Loader from '../../components/Loader'

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organizations: [],
            query: {
                organizations: []
            },
            search: ''
        };
        this.renderChild = this.renderChild.bind(this);
        this.renderEmpty = this.renderEmpty.bind(this);
    }
    async componentDidMount() {
        const organizations = await fetchORganizationsNames(this.props.user.token);
        this.setState({ organizations: Array.isArray(organizations) ? organizations.map(o => ({ value: o.code, label: o.name })) : [] }, () => {
            this.props.retrieve(this.props.user.token)
        })
    }
    renderEmpty() {
        return (
           <Loader/>
        )
    }
    renderChild() {
        return (
            [
                { Header: 'Organization', accessor: 'organization' },
                { Header: 'Contact', accessor: 'user.name' },
                { Header: 'Username', accessor: 'user.username' },
                { Header: 'Position', id: 'positionCell', accessor: d => (d.position || '--') },
                {
                    Header: 'Options',
                    accessor: d => d,
                    className: "no-overflow",
                    id: 'options',
                    Cell: props => (
                        <DropdownButton
                            icon="mdi mdi-account-settings"
                            label="Options">
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/users/${props.value._id}`)}
                                icon="mdi mdi-pencil"
                                label="Edit" />
                            <DropdownButton.Option
                                onClick={() => {
                                    let confirm = window.confirm('Really wants to delete user ' + props.value.user.name + '?');
                                    if (confirm) {
                                        deleteUser(this.props.user.token, props.value._id)
                                            .then((user) => this.props.retrieve(this.props.user.token))
                                            .catch((err) => notify(err.message))
                                    }
                                }}
                                icon="mdi mdi-delete"
                                label="Delete" />
                        </DropdownButton>
                    )
                }
            ]
        )
    }
    render() {
        let results = this.props.users.data.filter(i => !!i.user).filter(i => testRegex(i.user.name, this.state.search));
        if (this.state.query.organizations.length > 0) {
            results = results.filter(u => this.state.query.organizations.indexOf(u.organization) !== -1);
        }
        let leftCol = "";
        let rightCol = "col-12";
        if (this.props.user.is_admin) {
            leftCol = "col-2";
            rightCol = "col-10";
        }
        return (
            <Page title="User Management">
                <div className="row">
                    {this.props.user.is_admin &&
                        <FormSelect
                            className={leftCol}
                            onChange={options => {
                                let { query } = this.state;
                                query.organizations = options ? options.map(o => o.value) : [];
                                this.setState({ query });
                            }}
                            value={this.state.query.organizations}
                            options={this.state.organizations}
                            searchable multi
                            placeholder="Organizations filter" />
                    }
                    <SearchWithAction
                        className={rightCol}
                        action="ADD USERS"
                        onActionClick={() => this.props.push('/users/new')}
                        onChange={search => this.setState({ search })} />
                </div>
                <CardBox>
                    <Table
                        id="users"
                        renderEmpty={this.renderEmpty}
                        columns={this.renderChild()}
                        data={results} />
                </CardBox>
            </Page >
        )
    }
}


const mapStateToProps = state => ({
    user: state.authReducer.user,
    users: state.users
})

const mapDispatchToProps = dispatch => ({
    retrieve(token) {
        dispatch(retrieve(token));
    },
    push(routeName) {
        dispatch(push(routeName));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(List);


// WEBPACK FOOTER //
// ./src/routers/Users/List.js